import { useState } from 'react'
import { ImageAd, SubmenuItem } from '@/lib/api/navigation/navigation.types'
import NavigationFooter from '../footer'
import Text from '../../text'
import Image from 'next/image'
import Link from 'next/link'

interface DesktopContentProps {
  className?: string
  submenuItems?: SubmenuItem[]
  imageAds: ImageAd[]
  setIsOpen: (isOpen: boolean) => void
}
const DesktopContent = ({
  submenuItems,
  className = '',
  imageAds,
  setIsOpen,
}: DesktopContentProps) => {
  const [selectedItemName, setSelectedItemName] = useState('')
  const [selectedItemContent, setSelectedItemContent] = useState<
    SubmenuItem[] | undefined
  >((submenuItems && submenuItems[0].subitems) || undefined)

  const handleSelectedItem = (submenuItem: SubmenuItem) => {
    setSelectedItemName(submenuItem.name)
    setSelectedItemContent(submenuItem.subitems)
  }
  const handleOnMouseLeave = (submenuItem: SubmenuItem) => {
    if (!submenuItem.subitems?.length) setSelectedItemName('')
  }

  return (
    <div className={`w-full md:h-[574px] ${className}`}>
      <NavigationFooter imageAds={imageAds}>
        <div className={'flex flex-1 md:h-full'}>
          <div
            className={
              'flex flex-1 flex-col gap-2 overflow-auto bg-grey-50 p-4'
            }
          >
            {submenuItems?.map((item, index) => (
              <Link
                href={`/product-categories/${item.slug}`}
                key={`DesktopMenuItem${index}`}
                onMouseEnter={() => handleSelectedItem(item)}
                onMouseLeave={() => handleOnMouseLeave(item)}
                onClick={() => setIsOpen(false)}
              >
                <div
                  className={
                    'flex cursor-pointer items-center justify-between px-4 py-2 hover:text-primary-600'
                  }
                >
                  <Text
                    as="p"
                    fontWeight={'normal'}
                    className={`md:leading-6.25 ${selectedItemName === item.name && 'text-primary-600'}`}
                  >
                    {item.name}
                  </Text>

                  {!!item.subitems?.length && (
                    <div className="flex size-5 items-center justify-center overflow-hidden">
                      <Image
                        width={10}
                        height={10}
                        quality={100}
                        src={'/icons/chevron-right.svg'}
                        alt={'/icons/chevron-right.svg'}
                        className={'w-1.5 transition-all'}
                      />
                    </div>
                  )}
                </div>
              </Link>
            ))}
          </div>

          <div className={'flex-1'}>
            <div
              className={'flex h-full flex-1 flex-col gap-2 overflow-auto p-4'}
            >
              {selectedItemContent &&
                !!selectedItemContent.length &&
                selectedItemContent.map((item, index) => (
                  <div key={`DesktopMenuSubitem${index}`}>
                    <Link
                      href={`/product-categories/${item.slug}`}
                      onClick={() => setIsOpen(false)}
                    >
                      <Text
                        as="p"
                        fontWeight={'normal'}
                        className={
                          'cursor-pointer px-4 py-2 leading-6.25 hover:text-primary-600'
                        }
                      >
                        {item.name}
                      </Text>
                    </Link>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </NavigationFooter>
    </div>
  )
}

export default DesktopContent
